import request from '../shared/request';

export default class PaymentService {
  static pay(data) {
    return request({
      url: `/transactions.json`,
      method: 'POST',
      data
    })
  }
}